<div class="global-settings">
  <div class="product-info-container">
    <div class="icon" *ngIf="_product.iconUrl">
      <img [src]="_product.iconUrl" />
    </div>
    <div class="icon" *ngIf="_product.iconType">
      <mat-icon>{{ _product.iconType }}</mat-icon>
    </div>
    <div class="name">
      {{ _product.name }}
    </div>
  </div>
  <a mat-button *ngIf="_product.productId === 'custom' && (notificationEnabled$ | async)" (click)="setToDefault()">
    {{ 'USER_NOTIFICATIONS.RESET_ALL_SETTINGS' | translate }}
  </a>
</div>
<div class="sections">
  <div class="section" *ngFor="let sectionToDisplay of sectionsToDisplay">
    <div class="title" *ngIf="sectionToDisplay.sectionType !== 'globalSettingsFlag'">
      {{ sectionToDisplay.name | translate }}
      <ng-container *ngIf="disabledSections.indexOf(sectionToDisplay.sectionType) > -1">
        <div class="disabled" [matTooltip]="'USER_NOTIFICATIONS.DISABLED_VIA_GLOBAL_SETTINGS' | translate">
          <mat-icon>lock</mat-icon>
          <span>
            {{ 'USER_NOTIFICATIONS.GLOBALLY_DISABLED' | translate }}
          </span>
        </div>
      </ng-container>
    </div>
    <ng-container
      *ngFor="let sectionData of sectionToDisplay.sections"
      [ngTemplateOutlet]="notificationSetting"
      [ngTemplateOutletContext]="{
        sectionData: sectionData,
        sectionName: sectionToDisplay.sectionType,
        child: false,
        disabled: disabledSections.indexOf(sectionToDisplay.sectionType) > -1
      }"
    ></ng-container>
  </div>
</div>
<ng-template
  #notificationSetting
  let-sectionData="sectionData"
  let-child="child"
  let-sectionName="sectionName"
  let-disabled="disabled"
>
  <div class="notification-setting" [ngClass]="{ 'child-element': child }">
    <div class="name" [ngClass]="{ disabled: disabled }">
      {{ sectionData.title }}
    </div>
    <div class="trinarySelect">
      <mat-select
        [disabled]="disabled"
        [value]="sectionData.value"
        (selectionChange)="updateSetting(sectionData, sectionName, $event.value)"
      >
        <mat-option *ngIf="!!bulk" [value]="STATUS_UNSET">
          {{ 'USER_NOTIFICATIONS.DONT_UPDATE' | translate }}
        </mat-option>
        <mat-option [value]="STATUS_DEFAULT">
          {{ 'USER_NOTIFICATIONS.DEFAULT' | translate }}
          <ng-container *ngIf="!bulk">
            <ng-container *ngIf="sectionData.defaultValue === STATUS_ENABLED">
              ({{ 'USER_NOTIFICATIONS.ENABLED' | translate }})
            </ng-container>
            <ng-container *ngIf="sectionData.defaultValue === STATUS_DISABLED">
              ({{ 'USER_NOTIFICATIONS.DISABLED' | translate }})
            </ng-container>
          </ng-container>
        </mat-option>
        <mat-option [value]="STATUS_ENABLED">
          {{ 'USER_NOTIFICATIONS.ENABLED' | translate }}
        </mat-option>
        <mat-option [value]="STATUS_DISABLED">
          {{ 'USER_NOTIFICATIONS.DISABLED' | translate }}
        </mat-option>
      </mat-select>
    </div>
  </div>
  <ng-container *ngIf="sectionData.children?.length > 0 && sectionData.value">
    <ng-container
      *ngFor="let childData of sectionData.children"
      [ngTemplateOutlet]="notificationSetting"
      [ngTemplateOutletContext]="{
        sectionData: childData,
        sectionName: sectionName,
        child: true,
        disabled: disabled
      }"
    ></ng-container>
  </ng-container>
</ng-template>
